module.exports = __webpack_public_path__ + "media/images/icon__minus@3x-fc1ed1d28a53c905c220e46102383d60.png";